function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "publish",
  transform: "translate(-241 -310)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1898",
  "data-name": "Group 1898",
  transform: "translate(248 317)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_28",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0.5px",
  d: "M11.884 4a1.457 1.457 0 0 0-.4 2.861 4.677 4.677 0 0 1-4.632 4.632 1.458 1.458 0 0 0-1.108-1.036V6.892a1.461 1.461 0 1 0-.584 0v3.565a1.46 1.46 0 1 0 1.74 1.618A5.254 5.254 0 0 0 12.071 6.9a1.457 1.457 0 0 0-.187-2.9zM4.58 5.461a.876.876 0 1 1 .876.876.876.876 0 0 1-.876-.876zm.876 7.3a.876.876 0 1 1 .876-.876.876.876 0 0 1-.875.879zm6.427-6.427a.876.876 0 1 1 .876-.876.876.876 0 0 1-.875.879z",
  "data-name": "Path 28",
  transform: "translate(-3.99 -4)"
})));

var SvgPublish = function SvgPublish(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPublish, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/publish.f12ac309.svg";
export { ForwardRef as ReactComponent };